import { Roles } from 'constants/AdminConstants';
import { initPostHog, identifyUser, setGroup, trackEvent } from 'services/posthog';
// Define analytics events as const for better type inference
var events = {
    activity_added: 'Activity Added',
    onboarding_completed: 'Onboarding Completed',
    onboarding_step_1: 'Onboarding Step 1 Completed',
    onboarding_step_2: 'Onboarding Step 2 Completed',
    onboarding_step_3: 'Onboarding Step 3 Completed',
    signed_in: 'User Signed In'
};
/**
 * Initialize PostHog analytics
 * @param key - PostHog API key from app_settings
 * @param host - PostHog host URL (defaults to US cloud)
 */
var init = function (key, host) {
    if (host === void 0) { host = 'https://us.i.posthog.com'; }
    initPostHog(key, host);
};
var group = function (company) {
    var getStatus = function (status) {
        switch (status) {
            case 2:
            case 3:
                return 'Paid';
            case 4:
                return 'Cancelled';
            case 1:
            default:
                return 'Unpaid';
        }
    };
    if (company) {
        setGroup(company.account.id.toString(), {
            name: company.account.account_name,
            avatar: company.account.logo,
            plan: parseInt(company.account.status, 10) === 2 ? 'Monthly' : '',
            status: getStatus(parseInt(company.account.status, 10)),
            numberOfTrackables: company.products.length,
            numberOfUsers: company.users.length,
            numberOfAllGames: company.games_list.all.length,
            numberOfOwnedGames: Object.keys(company.games_list.owned).length,
            numberOfGuestGames: company.games_list.guest.length,
            onboardingCompleted: company.account.onboarding_completed
        });
    }
};
var identify = function (user) {
    if (user) {
        identifyUser(user.id.toString(), {
            name: user.user_name,
            email: user.email,
            avatar: user.upload_url,
            role: parseInt(user.role_id, 10) === Roles.ADMINISTRATOR ? 'Coach' : 'Player'
        });
    }
};
var track = function (event, properties, _options, callback) {
    if (properties === void 0) { properties = {}; }
    if (_options === void 0) { _options = {}; }
    trackEvent(event, properties);
    if (callback) {
        callback();
    }
};
// @deprecated - PostHog handles page views automatically
var trackRouteChanges = function (history) {
    // PostHog autocaptures page views, this is now a no-op
    return history;
};
export { events, init, group, identify, track, trackRouteChanges };
